import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import '../style/GridModal.css';
import Zoomproduct from '../../../Component/Zoomproduct';
import AddCart from '../../Cart/AddCart';

const ModalBoxPopup = ({ Modal, detailModalShow, handleDetailModalClose, Button, currentImage, product  }) => {
  const [zoomModalShow, setZoomModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // Loading state

  const handleZoomClick = () => {
    setZoomModalShow(true);
  };

  const handleZoomClose = () => {
    setZoomModalShow(false);
  };

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 3000); 
  }, []);

  return (
    <>
      <Modal show={detailModalShow} onHide={handleDetailModalClose} fullscreen centered>
        <Modal.Body className="text-center modelboxoverflow">
          <Button
            variant="light"
            onClick={handleDetailModalClose}
            className="position-absolute top-0 end-0 close-btns"
            style={{ zIndex: 1050 }}
          >
            <i className="bi bi-x-lg"></i>
          </Button>
          <div className="box-Content-Ration">
            <div className="row">
              <div className="col-md-4">
                <div className="image-gallery position-relative">
                  {isLoading ? (
                    <Skeleton height={400} width="100%" />
                  ) : currentImage ? (
                    <img
                      src={currentImage}
                      alt="Detailed View"
                      style={{ width: '100%', height: 'auto' }}
                    />
                  ) : (
                    <p>No detailed data available.</p>
                  )}
                  <span
                    className="zoomicon"
                    onClick={handleZoomClick}
                    style={{
                      cursor: 'pointer',
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                    }}
                  >
                    <i className="bi bi-zoom-in"></i>
                  </span>
                </div>
               <h3 className="text-xl text-gray-500" style={{ fontSize: "16px" }} >
              {isLoading ? (
              <Skeleton width={150} />
              ) : (
              <>
              {product?.quality_name}{" "}

              <span
              style={{
              color: "#E13236",
              fontWeight: 400,
              }}
              >
              {product?.designshade?.split(" ").map((word, index, words) => (
              <React.Fragment key={index}>
              {index === 0
              ? word.split(/(\d+)/).map((part, i) =>
              /^\d+$/.test(part) ? (
              <span key={i}>{part}</span>
              ) : (
              <strong key={i}>{part}</strong>
              )
              )
              : word}

              {index < words.length - 1 && " "}
              </React.Fragment>
              ))}
              </span>
              </>
              )}
               </h3>
              </div>
              <div className="col-md-8">
              <div className="text-left">
                
                   <AddCart sizes={product?.sizes || []} />

                    <h4 className="text-gray-500 pt-2 font-normal">
                    {isLoading ? <Skeleton width={100} /> : "SPECIFICATION"}
                  </h4>
                  <p className="text-gray-600" style={{ background:"#e1e1e1", padding:"0 4px"}}>
                    {isLoading ? (
                      <Skeleton count={3} />
                    ) : (
                      product?.description
                    )}
                  </p>
                 </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Zoom Modal */}
      
      <Zoomproduct
        show={zoomModalShow}
        onHide={handleZoomClose}
        currentImage={currentImage}
      />
    </>
  );
};

export default ModalBoxPopup;
